module.exports = __webpack_public_path__ + "img/01.1273f6d9.png";